// text / email / tel / number / textarea — one renderer, mode set by schema type.
import React from "react";
import { TextField } from "@mui/material";
import FieldFrame from "./FieldFrame";

const HTML_TYPE = { text: "text", email: "email", phone: "tel", number: "text" };

const TextInput = ({ field, value, error, disabled, onChange, onBlur }) => {
  const id = `f-${field.name}`;
  const multiline = field.type === "textarea";

  return (
    <FieldFrame
      label={field.label}
      required={field.required}
      help={field.help}
      error={error}
      htmlFor={id}
    >
      <TextField
        id={id}
        fullWidth
        size="small"
        variant="outlined"
        name={field.name}
        type={HTML_TYPE[field.type] || "text"}
        value={value ?? ""}
        placeholder={field.placeholder}
        disabled={disabled}
        error={!!error}
        multiline={multiline}
        minRows={multiline ? field.props?.minRows || 3 : undefined}
        // `inputMode` gives mobile the right keyboard without the spinner and
        // locale-formatting surprises of <input type="number">.
        inputProps={{
          inputMode: field.type === "number" || field.type === "phone" ? "numeric" : undefined,
          maxLength: field.props?.maxLength,
          "aria-invalid": !!error,
        }}
        onChange={onChange}
        onBlur={onBlur}
        {...field.props}
      />
    </FieldFrame>
  );
};

export default TextInput;
